import {Component, Injector, Input, OnInit, ViewChild} from '@angular/core';
import {ShopBaseComponent} from "../../shop/shop-base.component";
import {Company} from "../../../models/company";
import {CompanyService} from "../../../services/company/company.service";

@Component({
    selector: 'app-shop-navbar',
    templateUrl: './shop-navbar.component.html',
    styleUrls: ['./shop-navbar.component.scss']
})
export class ShopNavbarComponent extends ShopBaseComponent implements OnInit {

    @Input() company: Company = new Company();
    @ViewChild('cartBadge') cartBadge: any;

    activeMenu: number = 0;
    isWellDoneUser: boolean = false;
    dashboardUrl: string = '';
    mobileMenuOpen: boolean = false;

    constructor(
        public serviceInjector: Injector,
        private companyService: CompanyService,
    ) {
        super(serviceInjector);
    }

    async ngOnInit() {
        this.company = (await this.companyService.getCompanyById(localStorage.getItem('wisper_companyId') ?? '')).data;
        this.isWellDoneUser = localStorage.getItem('wisper_userId') != null;
        const userType = localStorage.getItem('wisper_userGroup');
        if (userType === 'admin') {
            this.dashboardUrl = '/admin/dashboard';
        } else if (userType === 'companyManager') {
            this.dashboardUrl = 'company/dashboard';
        } else if (userType === 'mister') {
            this.dashboardUrl = '/misters/dashboard';
        } else if (userType === 'user') {
            this.dashboardUrl = 'user/dashboard';
        } else {
            this.dashboardUrl = 'shop/products';
        }
    }

    setActiveMenu(menuIndex: number) {
        console.log('setActiveMenu')
        this.activeMenu = menuIndex;
    }


}
